import { render, staticRenderFns } from "./editImg.vue?vue&type=template&id=3ac72bc1&scoped=true&"
import script from "./editImg.vue?vue&type=script&lang=js&"
export * from "./editImg.vue?vue&type=script&lang=js&"
import style0 from "./editImg.vue?vue&type=style&index=0&id=3ac72bc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac72bc1",
  null
  
)

export default component.exports